import React, { FC, useEffect, useState } from "react";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";

import {
  useGetPaymentInformationQuery,
  useUpdateCustomerInformationMutation,
} from "../../../store/pomeriumApi";

type UpdateBillingCustomerInformationDialogProps = {
  organizationId?: string;
  open: boolean;
  onClose: () => void;
};

const UpdateBillingCustomerInformationDialog: FC<
  UpdateBillingCustomerInformationDialogProps
> = ({ organizationId, open, onClose }) => {
  const { data: paymentInformation } = useGetPaymentInformationQuery(
    organizationId || "",
    { skip: !organizationId || !open },
  );
  const [updateCustomerInformation, { isLoading }] =
    useUpdateCustomerInformationMutation();
  const [email, setEmail] = useState("");

  useEffect(() => {
    setEmail(paymentInformation?.billingEmail || "");
  }, [paymentInformation?.billingEmail]);

  const onChangeEmail = (
    evt: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
  ) => {
    setEmail(evt.target.value);
  };
  const onSubmit = (evt: React.FormEvent<HTMLFormElement>) => {
    evt.preventDefault();

    (async () => {
      await updateCustomerInformation({
        organizationId: organizationId || "",
        updateCustomerInformationRequest: {
          email,
        },
      });
      onClose();
    })();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        component: "form",
        onSubmit: onSubmit,
      }}
    >
      <DialogTitle>Update Customer Information</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          required
          margin="dense"
          id="name"
          name="email"
          label="Billing Email"
          type="email"
          fullWidth
          variant="standard"
          value={email}
          onChange={onChangeEmail}
        />
      </DialogContent>
      <DialogActions>
        <Button disabled={isLoading} onClick={onClose}>
          Cancel
        </Button>
        <Button disabled={isLoading} type="submit">
          Update
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default UpdateBillingCustomerInformationDialog;
